export const focusOnInput = (input) => {
  if (!input) {
    return;
  }

  if (!input.getRenderedComponent) {
    return;
  }
  const component = input.getRenderedComponent();
  component.focus();
}
